export default {
  brands: [],
  error: false,
  errorMessage: "",
  success: false,
  successMessage: "",
};
